export default __webpack_public_path__ + "static/job_placement-0fa73bee5cb05eeaef8907db3256bd0e.png";